// extracted by mini-css-extract-plugin
export default {"loaderContainer":"PackageServiceDetailsContent_loaderContainer__Zabil"};